module.exports = __webpack_public_path__ + "img/home-2-INTpeople.580ff35c.png";